/* eslint-disable */
export default {
  download: '다운로드',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
